// Memoria Alpha y Repeticion Inteligente.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Memoria Alpha (Mis recuerdos) ----

export const trackMemory = async (payload) => {
  const { data } = await api.post("/memory/track", payload);
  return data;
};

export const getMemoryOverview = async () => {
  const { data } = await api.get("/memory/overview");
  return data;
};

// Un fallo en una actividad de una leccion entra en el Olvido con su concepto detras.
//
// SUSTITUYE A `addLearning`, que era el «anotar un concepto» a mano. Pedirle a alguien de
// catorce años que apunte lo que no sabe es pedirle lo unico que no puede hacer: lo que no
// sabe, no sabe que no lo sabe. La plataforma acaba de verle fallar; eso si lo sabe.
//
// Se manda la actividad ENTERA y no un identificador: de ella salen el concepto -cruzandola
// con las flashcards de su leccion- y la actividad que se le volvera a poner tras las
// tarjetas, que es lo que convierte el repaso en una comprobacion.
export const apuntaFallo = async ({ lessonId, actividad, indice = 0, courseSlug = null }) => {
  const { data } = await api.post("/memory/fallo", {
    lesson_id: lessonId, actividad, indice, course_slug: courseSlug,
  });
  return data;
};

// Como le fue al alumno con una leccion: cuantas actividades tenia y cuantas fallo al
// menos una vez. Es OTRO dato que el fallo: aquel dice QUE no supo, este dice CUANTO.
//
// Se manda al terminar el bloque de actividades, sin esperar respuesta. Mandarla dos veces
// no es un error: el backend se queda con la primera nota a proposito -es la que mide lo
// que sabia, no lo que insistio-, asi que la pantalla no tiene que llevar la cuenta.
// `falladas` son los enunciados de las que fallo (18 oct 2026), para la ficha y el grupo.
export const apuntaResultado = async ({ lessonId, total, fallados, falladas = [], courseSlug = null }) => {
  const { data } = await api.post("/memory/leccion", {
    lesson_id: lessonId, total, fallados, falladas, course_slug: courseSlug,
  });
  return data;
};

// UN MINUTO CON UNA LECCION ABIERTA Y ACTIVA (W18). El servidor guarda el total del dia.
export const lateElEstudio = () => api.post("/memory/estudio").then((r) => r.data);

// Cuanto lleva el alumno de un curso: su media y la de cada modulo. Lo enseña el encabezado de la
// leccion. El panel que lo pintaba se fue el 8 de octubre de 2026, y el dato siguio siendo bueno.
export const getMiDominio = (cursoId) => api.get(`/memory/dominio/${cursoId}`).then((r) => r.data);

export const updateLearning = async (id, status) => {
  const { data } = await api.patch(`/memory/learnings/${id}`, { status });
  return data;
};

export const deleteLearning = async (id) => {
  const { data } = await api.delete(`/memory/learnings/${id}`);
  return data;
};

// ---- Repetición Inteligente (repaso de olvidos) ----

export const getReviewSession = async () => {
  const { data } = await api.post("/memory/review/session");
  return data;
};

export const submitReview = async (learningId, correct) => {
  const { data } = await api.post(`/memory/learnings/${learningId}/review`, { correct });
  return data;
};

// ---- La Biblioteca Viva: los libros (C8) ----

// Lo que se le ofrece hoy, su estante, y el nivel con el que se han elegido.
//
// `nivel` es el mando de la pantalla y NO SE GUARDA en ningun sitio: sale del curso del
// alumno mientras no lo mueva. Un dato que cambia en un trimestre envejece peor guardado
// que sin guardar, y ademas es uno menos que custodiar de un menor.
export const getLecturas = async (nivel = null) => {
  const { data } = await api.get("/memory/lecturas", nivel ? { params: { nivel } } : undefined);
  return data;
};

// La Biblioteca entera, por temática. Va aparte de las recomendaciones a propósito: éstas se
// recargan cada vez que se guarda un libro y el catálogo no cambia, así que se pide una vez.
export const getCatalogoLecturas = async () => {
  const { data } = await api.get("/memory/lecturas/catalogo");
  return data;
};

// Guardar un libro en el estante. Solo viaja el id: el titulo lo pone el catalogo del
// servidor, que es la diferencia entre guardar una referencia y dejar que se escriba lo
// que sea en la ficha de un alumno.
export const guardaLibro = async (libroId) => {
  const { data } = await api.post(`/memory/lecturas/${libroId}/estante`);
  return data;
};
